// extracted by mini-css-extract-plugin
export default {"content":"Uploader_content__MMt9u","box":"Uploader_box__mM8xo","tableContainer":"Uploader_tableContainer__aakZu","tbody":"Uploader_tbody__zP7MX"};